import styled from "styled-components";

export const ErrorMessage = styled.p`
  font-size: 2.5rem;
  text-align: center;
  color: #3a3a3a;
  padding: 3rem 0;
`;

export const RedirectMessage = styled.p`
  font-size: 1.25rem;
  text-align: center;
`;
